var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-star-mono"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9617 1.6058L12.9009 5.53497C13.0567 5.8508 13.3584 6.06997 13.7076 6.1208L18.0434 6.7508C18.9217 6.8783 19.2734 7.95913 18.6367 8.5783L15.4992 11.6366C15.3749 11.7579 15.2818 11.9076 15.2281 12.0728C15.1744 12.238 15.1616 12.4137 15.1909 12.585L15.9317 16.9033C16.0817 17.7791 15.1634 18.4458 14.3776 18.0333L10.4992 15.9941C10.3456 15.9133 10.1745 15.871 10.0009 15.871C9.82725 15.871 9.65622 15.9133 9.50256 15.9941L5.62423 18.0333C4.83756 18.4458 3.91923 17.7791 4.06923 16.9033L4.81006 12.585C4.83923 12.4137 4.82642 12.238 4.77271 12.0728C4.71901 11.9076 4.62602 11.758 4.50173 11.6366L1.36423 8.5783C0.728395 7.95913 1.07923 6.8783 1.95839 6.7508L6.29339 6.1208C6.64256 6.06997 6.94506 5.8508 7.10089 5.53497L9.03923 1.6058C9.43256 0.809134 10.5684 0.809134 10.9617 1.6058Z",
    fill: "#989BA2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuReview);
export default __webpack_public_path__ + "static/media/icon_menu_review.192aeb768d2cc39b58f93e6e0d366756.svg";
export { ForwardRef as ReactComponent };